import AppBar from '@mui/material/AppBar';
import React from 'react';
import Link, { LinkProps } from '~/components/Link';
import LogoActGateway from '~/components/LogoActGateway';
import { StyledGridContainer, StyledGridItem } from './styles';
export interface TopHeaderProps {
  logoHref?: LinkProps['href'];
  centerElement?: React.ReactNode;
  rightElement: React.ReactNode;
}
export const TopHeader: React.FC<TopHeaderProps> = ({
  logoHref,
  centerElement,
  rightElement
}: TopHeaderProps): React.ReactElement<TopHeaderProps> => {
  return <AppBar color="inherit" elevation={1} position="static" data-sentry-element="AppBar" data-sentry-component="TopHeader" data-sentry-source-file="index.tsx">
      <StyledGridContainer container data-sentry-element="StyledGridContainer" data-sentry-source-file="index.tsx">
        <StyledGridItem item justifyContent="flex-start" xs={4} data-sentry-element="StyledGridItem" data-sentry-source-file="index.tsx">
          {logoHref ? <Link href={logoHref} style={{
          alignItems: 'center',
          display: 'flex',
          height: '100%'
        }}>
              <LogoActGateway />
            </Link> : <LogoActGateway />}
        </StyledGridItem>
        <StyledGridItem item justifyContent="center" xs={4} data-sentry-element="StyledGridItem" data-sentry-source-file="index.tsx">
          {centerElement}
        </StyledGridItem>
        <StyledGridItem item justifyContent="flex-end" xs={4} data-sentry-element="StyledGridItem" data-sentry-source-file="index.tsx">
          {rightElement}
        </StyledGridItem>
      </StyledGridContainer>
    </AppBar>;
};
export default TopHeader;